import React from "react";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { RenderTextInput } from "../../../common/renderInput";

const ApiGroupForm = ({
  tagMarkup,
  commissionMarkup,
  show,
  initialValues,
  toggleEditorDialog,
  handleFormSubmit,
}) => {
  return (
    <Modal
      show={show ? true : false}
      backdropClassName={false}
      backdrop="static"
      keyboard={false}
      onHide={toggleEditorDialog}
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          {initialValues ? "Update" : "New"} API Group
        </h5>
      </div>
      <div className="modal-body">
        <Formik
          initialValues={
            initialValues
              ? initialValues
              : {
                  id: 0,
                  name: "",
                  validTo: "",
                }
          }
          validationSchema={contactSchema}
          enableReinitialize={true}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="position-relative">
              <div className="form-row">
                <RenderTextInput
                  type="text"
                  name="name"
                  display="API Group Name"
                  placeholder="API Group Name"
                  value={values.name}
                  error={errors.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.name}
                  required
                ></RenderTextInput>
              </div>

              <div className="form-row">
                <RenderTextInput
                  type="date"
                  name="validTo"
                  display="Valid To"
                  placeholder="Valid To"
                  value={values.validTo}
                  error={errors.validTo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.validTo}
                  required
                ></RenderTextInput>
              </div>
              <div className="form-group row">
                <div className="col-sm-12 text-center">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => toggleEditorDialog(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {initialValues ? "Update" : "Create"} Group
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

const contactSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required."),
  tagMarkupId: yup.number().min(1, "Please select Tag Markup.").nullable(),
  commissionMarkupId: yup
    .number()
    .min(1, "Please select Commission Markup.")
    .nullable(),
  validTo: yup.date().required("Please select Valid To date."),
});

export default ApiGroupForm;
